import GenericExportButton from "components/GenericExportButton";
import { saveObjectToCsv } from "helpers/excelHelper";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  EnrollmentAssigner,
  EnrollmentsFilter,
  ListRequestOfEnrollmentsFilter,
} from "services/organizationPortalClient";
import contextStore from "stores/contextStore";

type ExportEnrollmentsProps = {
  sortField: string;
  sortDescending: boolean;
  filter: EnrollmentsFilter;
};

const MAX_ENROLLMENTS_TO_EXPORT = 10000;

const ExportEnrollments = ({
  sortField,
  sortDescending,
  filter,
}: ExportEnrollmentsProps) => {
  const { formatMessage: t } = useIntl();
  const { organization } = contextStore.useState();
  const { enrollmentService } = useGlobalContext();

  const exportEnrollments = async (): Promise<void> => {
    const enrollmentsResponse = await enrollmentService.getEnrollments(
      ListRequestOfEnrollmentsFilter.fromJS({
        pageSize: MAX_ENROLLMENTS_TO_EXPORT,
        sortField: sortField,
        sortDescending: sortDescending,
        parameters: filter,
      })
    );

    const enrollmentsToExport =
      enrollmentsResponse?.data?.map((e) => ({
        "Enrollment Date": e.enrollmentDate,
        Name: e.firstName,
        "Last Name": e.lastName,
        Email: e.email,
        "Course Availability": e.availability,
        "Course Title": e.title,
        "Event Date": e.eventStartDate,
        Status: e.status,
        Format: e.skuFormat?.plainTextName,
        Profession: e.professions?.map((p) => p.name).join(", "),
        Credits: e.credits,
        "Assigned By": EnrollmentAssigner[e.assignedBy],
      })) ?? [];

    if (enrollmentsToExport.length) {
      saveObjectToCsv(
        organization!.name + " enrollments",
        enrollmentsToExport
      );
    } else {
      return Promise.reject(new Error(t({ id: "unexpectedExportError" })));
    }
  };

  return (
    <GenericExportButton
      exportData={exportEnrollments}
      tooltipLabel={t({ id: "exportEnrollments" })}
    />
  );
};

export default ExportEnrollments;
